import React from 'react'
import { highlightsSection } from '../../../constants/viemax-constants'

const Highlights = () => {
  return (
    <section className="bg-[linear-gradient(138deg,_#00AEE6_0%,_#29256A_78.11%)] p-[40px] mt-[40px] space-y-10">
      {highlightsSection?.highlights?.map((highlight, index) => (
        <div
          className="flex flex-row items-center gap-6"
          key={`viemax-care-highlights-${index}`}
        >
          <img src={highlight.image} className="h-[80px] w-[80px]" />
          <p className="font-[600] text-[16px] leading-[28px] text-white max-w-[60%]">
            {highlight.title}
          </p>
        </div>
      ))}
    </section>
  )
}

export default Highlights
